/**
 * Discount Service
 *
 * Handles discount/coupon code validation
 */

import api from './api';

export const discountService = {
  /**
   * Validate a discount code
   * @param {string} code - Discount code to validate
   * @param {number} cartTotal - Cart total in cents (before discount)
   * @returns {Promise<Object>} Validation result with discount details
   */
  validateDiscount: async (code, cartTotal) => {
    try {
      const response = await api.post('/discounts/validate', {
        code: code.toUpperCase(),
        cartTotal
      });
      return response.data;
    } catch (error) {
      console.error('[DiscountService] Validate discount error:', error);
      throw error;
    }
  }
};

export default discountService;
